/* ============================================================
   SAVIRA.JS — Sticky header, scroll reveal, product page JS
   ============================================================ */

// 1. Sticky header scroll shadow
(function () {
  var hdr = document.getElementById('site-header');
  if (!hdr) return;
  window.addEventListener('scroll', function () {
    hdr.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
})();

// 2. Scroll reveal — IntersectionObserver
(function () {
  if (!('IntersectionObserver' in window)) {
    // Fallback: show all reveal elements immediately
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('in');
    });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(function (el) {
    obs.observe(el);
  });
})();

// 3. Product gallery image switcher (product page only)
(function () {
  var mainImg = document.getElementById('main-product-img');
  if (!mainImg) return;

  var thumbs = Array.from(document.querySelectorAll('.thumb'));

  function activateThumb(thumb) {
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    var src = thumb.dataset.src;
    var srcset = thumb.dataset.srcset;
    var alt = thumb.dataset.alt || '';
    if (src) mainImg.src = src;
    if (srcset) mainImg.srcset = srcset;
    if (alt) mainImg.alt = alt;
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () { activateThumb(thumb); });
  });

  function getCurrent() {
    return thumbs.findIndex(function (t) { return t.classList.contains('active'); });
  }
  function navigate(delta) {
    var next = (getCurrent() + delta + thumbs.length) % thumbs.length;
    activateThumb(thumbs[next]);
  }

  var btnPrev = document.getElementById('img-prev');
  var btnNext = document.getElementById('img-next');
  if (btnPrev) btnPrev.addEventListener('click', function () { navigate(-1); });
  if (btnNext) btnNext.addEventListener('click', function () { navigate(1); });
})();

// 4. Quantity stepper (product page only)
(function () {
  var qtyEl = document.getElementById('product-qty');
  if (!qtyEl) return;
  var btnDec = document.getElementById('qty-dec');
  var btnInc = document.getElementById('qty-inc');
  if (btnDec) {
    btnDec.addEventListener('click', function () {
      var val = parseInt(qtyEl.value, 10);
      if (val > 1) qtyEl.value = val - 1;
    });
  }
  if (btnInc) {
    btnInc.addEventListener('click', function () {
      qtyEl.value = parseInt(qtyEl.value, 10) + 1;
    });
  }
})();

// 5. Variant selector — colour swatches + size buttons → sync hidden <select name="id">
(function () {
  var variantSelect = document.querySelector('select[name="id"]');
  if (!variantSelect) return;

  function updateVariantSelect() {
    var selectedOptions = [];
    document.querySelectorAll('.option-group').forEach(function (group) {
      var active = group.querySelector('.size-btn.active, .swatch.active');
      if (active) selectedOptions.push(active.dataset.value);
    });
    if (selectedOptions.length === 0) return;

    Array.from(variantSelect.options).forEach(function (opt) {
      var parts = opt.text.replace(/ - .*$/, '').split(' / ').map(function (s) { return s.trim(); });
      if (selectedOptions.every(function (val) { return parts.indexOf(val) !== -1; })) {
        variantSelect.value = opt.value;
        variantSelect.dispatchEvent(new Event('change'));
      }
    });
  }

  document.querySelectorAll('.size-btn:not(.unavailable)').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.option-group');
      group.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      // Update label display
      var labelSpan = group.querySelector('.option-label span');
      if (labelSpan) labelSpan.textContent = btn.dataset.value;
      updateVariantSelect();
    });
  });

  document.querySelectorAll('.swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var group = sw.closest('.option-group');
      group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
      sw.classList.add('active');
      var labelSpan = group.querySelector('.option-label span');
      if (labelSpan) labelSpan.textContent = sw.dataset.value;
      updateVariantSelect();
    });
  });
})();

// 6. Accordion toggles (product page)
(function () {
  document.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var accordion = trigger.closest('.accordion');
      accordion.classList.toggle('open');
    });
  });
})();

// ============================================================
// 7. Cart page — AJAX quantity updates + remove
// ============================================================
(function () {
  var cartForm = document.getElementById('cart-form');
  if (!cartForm) return;

  // Helper: update cart via Cart API (uses window.routes for locale-safe URLs)
  var cartChangeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
  function cartChange(key, quantity, callback) {
    fetch(cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) { if (callback) callback(cart); })
    .catch(function (err) { console.error('Cart update failed:', err); });
  }

  // Helper: refresh page sections after cart change
  function refreshCartPage() {
    window.location.reload();
  }

  // Qty decrement
  document.querySelectorAll('.cart-qty-dec').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key   = btn.dataset.key;
      var input = document.querySelector('.cart-qty-input[data-key="' + key + '"]');
      if (!input) return;
      var newQty = Math.max(0, parseInt(input.value, 10) - 1);
      input.value = newQty;
      cartChange(key, newQty, refreshCartPage);
    });
  });

  // Qty increment
  document.querySelectorAll('.cart-qty-inc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key   = btn.dataset.key;
      var input = document.querySelector('.cart-qty-input[data-key="' + key + '"]');
      if (!input) return;
      var newQty = parseInt(input.value, 10) + 1;
      input.value = newQty;
      cartChange(key, newQty, refreshCartPage);
    });
  });

  // Qty input change (manual entry)
  document.querySelectorAll('.cart-qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var key    = input.dataset.key;
      var newQty = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = newQty;
      cartChange(key, newQty, refreshCartPage);
    });
  });

  // Remove item (intercept link for smooth UX)
  document.querySelectorAll('.item-remove').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var item = link.closest('.cart-item');
      var key  = item ? item.dataset.key : null;
      if (!key) { window.location.href = link.href; return; }
      // Fade out
      item.style.opacity = '0';
      item.style.transform = 'translateX(-20px)';
      item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      setTimeout(function () { cartChange(key, 0, refreshCartPage); }, 280);
    });
  });

  // Discount code — redirect to checkout with code pre-applied
  var promoBtn = document.getElementById('promo-apply-btn');
  if (promoBtn) {
    promoBtn.addEventListener('click', function () {
      var code = document.getElementById('promo-input').value.trim();
      if (code) {
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      }
    });
    document.getElementById('promo-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') promoBtn.click();
    });
  }
})();

// ============================================================
// 8. Collection page — filter toggles, sort, view toggle
// ============================================================
(function () {
  // Filter group collapse/expand
  document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.dataset.filterToggle;
      var group    = document.getElementById(targetId);
      if (!group) return;
      group.classList.toggle('collapsed');
      var icon = btn.querySelector('.filter-toggle');
      if (icon) icon.textContent = group.classList.contains('collapsed') ? '+' : '−';
    });
  });

  // Sort select — preserve existing URL params (filters)
  var sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // View toggle (2 vs 3 columns)
  var grid = document.getElementById('collection-grid');
  document.querySelectorAll('.view-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!grid) return;
      document.querySelectorAll('.view-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var cols = parseInt(btn.dataset.cols, 10);
      grid.classList.toggle('two-col', cols === 2);
    });
  });

  // Price range filter — apply on button click
  var priceApplyBtn = document.querySelector('[data-filter-price]');
  if (priceApplyBtn) {
    priceApplyBtn.addEventListener('click', function () {
      var minInput = document.getElementById('filter-price-min');
      var maxInput = document.getElementById('filter-price-max');
      if (!minInput || !maxInput) return;
      var url = new URL(window.location.href);
      // Price filter params use cents in Shopify storefront filtering
      var minCents = parseFloat(minInput.value || 0) * 100;
      var maxCents = parseFloat(maxInput.value || 0) * 100;
      if (minInput.name) url.searchParams.set(minInput.name, minCents);
      if (maxInput.name) url.searchParams.set(maxInput.name, maxCents);
      window.location.href = url.toString();
    });
  }

  // Per-page select
  var perPageSelect = document.getElementById('per-page-select');
  if (perPageSelect) {
    perPageSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('per_page', perPageSelect.value);
      url.searchParams.delete('page'); // reset to page 1
      window.location.href = url.toString();
    });
  }
})();
